import { render } from "./CommunicationItem.vue?vue&type=template&id=34c9577e&scoped=true"
import script from "./CommunicationItem.vue?vue&type=script&lang=js"
export * from "./CommunicationItem.vue?vue&type=script&lang=js"

import "./CommunicationItem.vue?vue&type=style&index=0&id=34c9577e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c9577e"]])

export default __exports__